import * as analyticalService from "../service/analyticalService";

export const saveAnalyticalData = (eventType, eventMetaData, rawString,user) => {
    try {
        let payload = {
                    eventType: eventType,
                    eventMetaData: eventMetaData,
                    actionDateTime: new Date().toISOString(),
                    rawSrting: rawString,
                    userID: user.userId,
                    platform: "Website",
                    mobileNo:user.countryCode+' '+user.mobileNo,
                    userType: user.userRole,
                    userName: user.userName,
                    deviceId:null,
                    environment:process.env.REACT_APP_ENVIRONMENT,
                    field1:null,
                    field2:null,
                    field3:null
                };
                analyticalService
                  .saveAnalyticalData(payload)
                  .then((response) => {
                  })
                  .catch((error) => {
                  });

        } catch (error) {
          }
        };